__turbopack_context__.v({
  "className": "SCDN6a_className",
  "variable": "SCDN6a_variable",
});
